import { useState } from 'react';
import { X } from 'lucide-react';

const UserCheckoutAlert = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="relative mb-2">
      <div className="bg-orange-100 text-xs p-4 rounded text-blue-800 relative ">
        {/* Close Button - Positioned Top Right */}
        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-1 right-1 text-blue-800 hover:text-blue-600"
        >
          <X size={16} />
        </button>
        <p className="text-sm leading-relaxed space-y-2">
          যদি ইতিপূর্বে আপনার নাম, ইমেইল, জেলা বা উপজেলা দিয়ে প্রোফাইল আপডেট না
          করে থাকেন, তাহলে এখানে প্রদত্ত তথ্য অনুযায়ী আপনার প্রোফাইল
          স্বয়ংক্রিয়ভাবে আপডেট হয়ে যাবে। নির্দিষ্ট উপজেলাভিত্তিক টেন্ডারের আপডেট
          নিয়মিতভাবে আপনার প্রদত্ত ইমেইলে পাঠানো হবে।
        </p>
      </div>
    </div>
  );
};

export default UserCheckoutAlert;
